import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// keep last scroll position before refresh
function saveScrollPosition() {
  sessionStorage.setItem('scrollPos', JSON.stringify([window.scrollX, window.scrollY]));
}

// add listeners for different page-exit events
window.addEventListener('beforeunload', saveScrollPosition); // Desktop fallback
window.addEventListener('pagehide', saveScrollPosition); // Better for mobile and bfcache
document.addEventListener('visibilitychange', () => {
  // Catch when the app is backgrounded
  if (document.visibilityState === 'hidden') {
    saveScrollPosition();
  }
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
